<template>
  <div class="loading-container">
    <van-loading type="spinner" :color="color" size="36px" class="loading">
      数据加载中...
    </van-loading>
  </div>
</template>
<script>
export default {
  name: 'loading',
  props: {
    color: {
      type: String,
      default: '#1989fa'
    }
  }
}
</script>
<style lang="stylus">
.loading-container {
  z-index 10
  position: fixed;
  left: 0;
  right: 0;
  top: 0; bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .loading {
    display flex
    flex-direction column
    align-items center
    .van-loading__text {
      margin-top 10px
    }
  }
}
</style>
